module.exports = {"510121001":"赵镇街道","510121101":"三星镇","510121102":"清江镇","510121103":"官仓镇","510121104":"淮口镇","510121105":"白果镇","510121106":"五凤镇","510121108":"高板镇","510121109":"三溪镇","510121110":"福兴镇","510121111":"金龙镇","510121112":"赵家镇","510121113":"竹篙镇","510121114":"广兴镇","510121115":"隆盛镇","510121116":"转龙镇","510121117":"土桥镇","510121118":"云合镇","510121119":"又新镇","510121200":"栖贤乡","510121203":"平桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510121.json
// module id = 2264
// module chunks = 0